import { useConcent } from 'concent';
import React from 'react';
import { Navigate } from 'react-router-dom';
// userAuths: 权限数组，auth_id：路由权限id，authWithPath：使用path建权
type IAuthRoute = {
  children: any;
  meta: Record<string, any> | null;
};
function AuthRoute(props: IAuthRoute) {
  const userCtx = useConcent({ module: 'user' });
  const { roleList } = userCtx.state;
  // 内部oa域名登录
  // if (roleList === null) {
  //   return;
  // }
  const { meta = {} } = props;
  if (meta?.white) {
    return props.children;
  }
  console.log('AuthRoute');
  return !roleList?.length ? <Navigate to="/exception-403" replace={true}></Navigate> : props.children;
}

export default AuthRoute;
